import type { BrandStatus } from '../../types';

/**
 * Small pill marking a brand/manufacturer lifecycle status in admin lists.
 * Renders nothing for `active` (the default) or missing status — only the
 * non-default states get a badge so admins can scan for historical entities.
 * - `defunct`  → muted grey
 * - `dormant`  → amber
 * - `revived`  → green-tinted
 * - `absorbed` → blue-tinted
 */
export function StatusBadge({ status }: { status?: BrandStatus }) {
  if (!status || status === 'active') return null;
  const config: Record<Exclude<BrandStatus, 'active'>, { label: string; className: string }> = {
    defunct: { label: 'Defunct', className: 'bg-gray-200 text-gray-600' },
    dormant: { label: 'Dormant', className: 'bg-amber-100 text-amber-700' },
    revived: { label: 'Revived', className: 'bg-green-100 text-green-700' },
    absorbed: { label: 'Absorbed', className: 'bg-blue-100 text-blue-700' },
  };
  const { label, className } = config[status];
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium ${className}`}
    >
      {label}
    </span>
  );
}
